import { useWindowDimensions } from './useWindowDimensions';

export function useWindowHeight() {
	const { height } = useWindowDimensions();
	return height;
}
